import { money } from "./money";

/**
 * How a plan card shows an offer: the list price struck through, the offer's
 * label, and the last day it can be claimed. Pure, so the copy is testable.
 *
 * The catalog prices every variant for the office being bought for
 * (usage.services.pricing): `price` is the effective monthly rate, `list_price`
 * the advertised one, and `charge.discount` what the offer takes off one charge.
 */
export function offerFor(variant) {
  if (!variant || !variant.charge) return null;
  const discount = Number(variant.charge.discount || 0);
  if (!(discount > 0)) return null;
  const offer = variant.offer || variant.charge.offer || {};
  return {
    label: offer.label || "Special offer",
    endsOn: offer.expires_on || null,
    listPrice: variant.list_price != null ? String(variant.list_price) : null,
    discount: String(variant.charge.discount),
  };
}

/** "Offer ends Oct 31, 2026" — a date the customer reads, in their own terms. */
export function offerEndsText(isoDate) {
  if (!isoDate) return "";
  const [y, m, d] = String(isoDate).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return "";
  const date = new Date(y, m - 1, d);
  return `Offer ends ${date.toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" })}`;
}

/** "$100 off" / "$1,197 off" — the saving on one charge. */
export function offerSavingText(offer) {
  if (!offer) return "";
  return `$${money(offer.discount)} off`;
}
